import "./App.css";

function App() {
  return (
    <div className="App">
      <div style={{ padding: "2rem", textAlign: "center", display: "none" }}>
        <h1>IP Filing Services</h1>
        <p>React app is running successfully</p>
      </div>
    </div>
  );
}

export default App;
